import React from "react";

const TERMS_SECTIONS = [
  {
    title: "Acceptance of Terms",
    points: [
      "By using this website, you agree to follow these terms and applicable school policies.",
      "If you do not agree with any term, please discontinue use of the site.",
    ],
  },
  {
    title: "Use of Website Content",
    points: [
      "All website content, branding, and media are owned or licensed by the school.",
      "Reproduction, copying, or commercial use without written approval is prohibited.",
    ],
  },
  {
    title: "Admissions and Information Accuracy",
    points: [
      "Parents/guardians must provide accurate and complete details in forms and applications.",
      "The school may reject or cancel requests where submitted information is incomplete or incorrect.",
    ],
  },
  {
    title: "Limitation of Liability",
    points: [
      "The school is not liable for losses arising from website downtime, interruptions, or third-party service failures.",
      "Use of this website is at the user's own discretion and risk.",
    ],
  },
  {
    title: "Governing Law",
    points: [
      "These terms are governed by the laws and legal jurisdiction applicable to the school's operations.",
      "Any disputes will be handled under the competent legal forums of that jurisdiction.",
    ],
  },
];

function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-10">
      <div className="mx-auto max-w-5xl space-y-6">
        <section className="rounded-3xl bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 p-8 text-white shadow-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-100">
            Legal
          </p>
          <h1 className="mt-3 text-3xl font-semibold text-white sm:text-4xl">
            Terms of Service
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-6 text-blue-100 sm:text-base">
            These terms define how visitors, parents, and applicants should use
            the Rising Stars Public School website and services.
          </p>
          <div className="mt-5 inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-blue-100">
            Last Updated: March 20, 2026
          </div>
        </section>

        <section className="grid gap-5">
          {TERMS_SECTIONS.map((section) => (
            <article
              key={section.title}
              className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md"
            >
              <h2 className="text-2xl font-semibold text-slate-900">
                {section.title}
              </h2>
              <ul className="mt-4 space-y-2 text-sm leading-6 text-slate-700 sm:text-base">
                {section.points.map((point) => (
                  <li
                    key={point}
                    className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
